module directives {
    export module logistics {
        interface IActualCostReviewDirective extends ng.IScope {
            consignmentImportALCData: interfaces.consignment.IConsignmentImportALCData[];
            consignmentImportALCDataFiltered: interfaces.consignment.IConsignmentImportALCData[];
            isLoading: boolean;
            entity: interfaces.applicationcore.IDropdownModel;
            shippedOnBoardDateFrom: moment.Moment;
            shippedOnBoardDateTo: moment.Moment;
            LoadConsignmentImportALCData();
            downloadExcel();
            loadEntities(searchText: string);
            getCurrentEntity();
            searchText: string;
            searchChanged();
            replaceAll(str : string, find: string, replace: string):string;
        }

        export class actualCostReviewDirective implements ng.IDirective {
            templateUrl = 'templates/modules/applicationmain/logistics/actualCostReviewView.html';
            scope = {
            }

            public consignmentImportALCData: interfaces.consignment.IConsignmentImportALCData[];

            constructor(
                private generalService: interfaces.applicationcore.IGeneralService,
                private $state: ng.ui.IStateService,
                private bsLoadingOverlayService,
                private consignmentService: interfaces.consignment.IConsignmentService,
                private menuService: interfaces.applicationcore.IMenuService,
                private tariffCountryService: interfaces.tariff.ITariffCountryService,
                private entityService: interfaces.applicationcore.IEntityService,
                private $q: ng.IQService,
            ) {

                

            }

            link = ($scope: IActualCostReviewDirective, $element: ng.IAugmentedJQuery, $state) => {

                $scope.shippedOnBoardDateFrom = moment(new Date()).add(-9, "months");
                $scope.shippedOnBoardDateTo = moment(new Date()).add(-3, "months");

                $scope.getCurrentEntity = () => {
                    return this.entityService.getCurrentEntity().query((resultEntity: interfaces.applicationcore.IEntity) => {
                        //$scope.ownerEntityId = resultEntity.Id;    
                        $scope.entity = <interfaces.applicationcore.IDropdownModel>{
                            Id: resultEntity.Id,
                            Code: resultEntity.Code,
                            Description: resultEntity.Name,
                            Display: resultEntity.Code + " - " + resultEntity.Name,
                            Selected: true
                        }; 

                        $scope.LoadConsignmentImportALCData();
                    }, (failureData) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    }).$promise;
                }  

                $scope.LoadConsignmentImportALCData = () => {

                    var connectSearch: interfaces.applicationcore.ISearchObject = {
                        filters: [],
                        sorts: []
                    }

                    connectSearch.filters.push({ Name: "EntityId", Value: $scope.entity.Id});
                    connectSearch.filters.push({ Name: "ShippedOnBoardDateFrom", Value: $scope.shippedOnBoardDateFrom });
                    connectSearch.filters.push({ Name: "ShippedOnBoardDateTo", Value: $scope.shippedOnBoardDateTo });

                    $scope.isLoading = true;
                    return this.consignmentService.getConsignmentImportALC().query( {connectSearch}
                    , (resultList) => {
                        $scope.consignmentImportALCData = resultList;
                        $scope.consignmentImportALCDataFiltered = resultList;
                        $scope.isLoading = false;
                    }).$promise;
                }

                $scope.getCurrentEntity();

 
                $scope.searchChanged = () =>{
                 
                    $scope.consignmentImportALCDataFiltered = [];
                    for (var i = 0; i < $scope.consignmentImportALCData.length; i++){    
                       
                        if (JSON.stringify($scope.consignmentImportALCData[i]).toLocaleLowerCase().includes($scope.replaceAll($scope.searchText.toLocaleLowerCase(),'/','-')))
                        {
                            $scope.consignmentImportALCDataFiltered.push($scope.consignmentImportALCData[i]);
                        }
                    }
                }

                $scope.replaceAll = (str, find, replace) => {
                    return str.replace(new RegExp(find, 'g'), replace);
                  }

                //Loading Entities
                $scope.loadEntities = (searchText: string) => {
                    return this.entityService.getDropdownList(searchText).query(
                        () => {
                        }, (failureData) => {
                        }).$promise;
                }

                $scope.downloadExcel = () =>{

                    var connectSearch: interfaces.applicationcore.ISearchObject = {
                        filters: [],
                        sorts: []
                    }

                    connectSearch.filters.push({ Name: "EntityId", Value: $scope.entity.Id});
                    connectSearch.filters.push({ Name: "ShippedOnBoardDateFrom", Value: $scope.shippedOnBoardDateFrom });
                    connectSearch.filters.push({ Name: "ShippedOnBoardDateTo", Value: $scope.shippedOnBoardDateTo });

                    $scope.isLoading = true;
                    this.consignmentService.getConsignmentImportALCExcel({connectSearch}).then(() => {
                        $scope.isLoading = false;
                    }, (data) => {
                        $scope.isLoading = false;
                    });
                }

            }

            static factory(): ng.IDirectiveFactory {
                const directive = (generalService, $state, 
                    bsLoadingOverlayService, consignmentService,menuService,tariffCountryService,entityService, $q) => new actualCostReviewDirective(generalService, $state, bsLoadingOverlayService, consignmentService,menuService,tariffCountryService,entityService, $q);
                directive.$inject = ["generalService", "$state", "bsLoadingOverlayService", "consignmentService","menuService","tariffCountryService","entityService", "$q"];

                return directive;
            }
        }

        angular.module("app").directive("gtsActualCostReview", actualCostReviewDirective.factory());
    }
}